<template>
  <v-card flat class="input-card pa-4">
    <div class="preset-display mb-6">
      <div class="d-flex flex-wrap justify-center">
        <v-chip v-for="(setting, i) in fixedSettings" :key="i" class="ma-2 preset-chip" large>
          <v-icon left>{{ setting.icon }}</v-icon>
          {{ setting.value }}
        </v-chip>
      </div>
    </div>

    <div class="text-center timer-section">
      <div class="display-time-wrapper">
        <div class="display-time monospace" :class="{ running: running }">{{ formattedTime }}</div>
      </div>

      <div class="controls-wrapper mt-4">
        <v-btn fab small color="rgba(255, 255, 255, 0.1)" @click="resetTimer" class="control-btn">
          <v-icon>mdi-restart</v-icon>
        </v-btn>
        <v-btn fab large color="#ffed00" @click="toggleTimer" class="mx-4 play-pause-btn">
          <v-icon size="36" color="black">{{ running ? "mdi-pause" : "mdi-play" }}</v-icon>
        </v-btn>
        <v-btn fab small color="rgba(255, 255, 255, 0.1)" @click="submit" :disabled="milliseconds === 0" class="control-btn">
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "HyroxInput",
  props: ["exercise", "planSettings"],
  data() {
    return {
      milliseconds: 0,
      timer: null,
      running: false,
      startTime: null,
    }
  },
  computed: {
    fixedSettings() {
      const settings = []
      const weight = this.planSettings.find((s) => s.text === "Gewicht")?.value
      const reps = this.planSettings.find((s) => s.text === "Wiederholungen")?.value
      const distance = this.planSettings.find((s) => s.text === "Distanz")?.value

      if (weight) settings.push({ icon: "mdi-weight-kilogram", value: `${weight} kg` })
      if (reps) settings.push({ icon: "mdi-counter", value: `${reps} Reps` })
      if (distance) settings.push({ icon: "mdi-map-marker-distance", value: `${distance} m` })

      return settings
    },
    formattedTime() {
      const totalSeconds = Math.floor(this.milliseconds / 1000)
      const min = String(Math.floor(totalSeconds / 60)).padStart(2, "0")
      const sec = String(totalSeconds % 60).padStart(2, "0")
      const hund = String(Math.floor((this.milliseconds % 1000) / 10)).padStart(2, "0")
      return `${min}:${sec}:${hund}`
    },
  },
  methods: {
    toggleTimer() {
      this.running ? this.pauseTimer() : this.startTimer()
    },
    startTimer() {
      if (this.running) return
      this.running = true
      this.startTime = Date.now() - this.milliseconds
      this.timer = setInterval(() => {
        this.milliseconds = Date.now() - this.startTime
      }, 51)
    },
    pauseTimer() {
      clearInterval(this.timer)
      this.running = false
    },
    resetTimer() {
      this.pauseTimer()
      this.milliseconds = 0
    },
    submit() {
      this.pauseTimer()
      if (this.milliseconds > 0) {
        // Erstelle den Payload mit den festen Vorgaben UND der gemessenen Zeit
        const payload = [...this.planSettings]
        payload.push({ text: "Dauer", value: (this.milliseconds / 1000).toFixed(2) })

        this.$emit("add-set", payload)
        this.resetTimer()
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style scoped>
.input-card {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  padding: 0 !important;
}
.section-title {
  font-weight: 500;
}
.preset-chip {
  font-size: 1.1rem !important;
  padding: 0 16px !important;
  height: 48px !important;
  background: rgba(255, 237, 0, 0.1) !important;
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 237, 0, 0.5) !important;
  color: #ffed00 !important;
  font-weight: 700;
  box-shadow: 0 0 10px rgba(255, 237, 0, 0.2);
}
.preset-chip .v-icon {
  color: #ffed00 !important;
}

.display-time-wrapper {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
}

.display-time {
  font-size: 3.5rem;
  font-weight: 700;
  color: #ffffff;
  padding: 16px;
  font-family: 'Roboto Mono', monospace;
  letter-spacing: 2px;
  transition: all 0.3s ease;
  text-shadow: 0 2px 10px rgba(0,0,0,0.3);
}
.display-time.running {
  color: #ffed00;
  text-shadow: 0 0 25px rgba(255, 237, 0, 0.8);
}

.controls-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.control-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255,255,255,0.1);
  backdrop-filter: blur(4px);
}

.play-pause-btn {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.4), 0 0 25px rgba(255, 237, 0, 0.6) !important;
}
</style>
